import { render } from "./S97860.vue?vue&type=template&id=55a2e540"
const script = {}
script.render = render

export default script